<template>
  <div id="ratings">
    <div class="d-inline-block stars">
      <i v-for="star in stars" class="material-icons">{{ star }}</i>
    </div>
    <a href="#" @click.prevent="scrollTo('reviews')" class="d-inline-block" style="color: black; font-size: 0.8rem; padding: 0.2rem;">
      ({{ loadedRatingCount }})
    </a>
    <b-btn v-if="1 === 2" @click="scrollTo('reviews')" variant="secondary" class="d-inline-block" style="color: white; font-size: 0.8rem; line-height: 0.8rem; padding: 0.2rem; margin-top: -0.2rem;">
      view
    </b-btn>
  </div>
</template>

<script>
export default {
  name: 'ratings',
  props: {
    rating: {
      type: Number,
      required: false,
      default: () => 0
    },
    count: {
      type: Number,
      required: false,
      default: () => 0
    }
  },
  data () {
    return {
      loadedRating: this.rating,
      loadedRatingCount: this.count,
      stars: [
        'star_border',
        'star_border',
        'star_border',
        'star_border',
        'star_border'
      ]
    }
  },
  methods: {
    animate: function (elem, style, unit, from, to, time, prop) {
      if (!elem) {
        return
      }
      var start = new Date().getTime(),
        timer = setInterval(function () {
          var step = Math.min(1, (new Date().getTime() - start) / time)
          if (prop) {
            elem[style] = (from + step * (to - from))+unit
          } else {
            elem.style[style] = (from + step * (to - from))+unit
          }
          if (step === 1) {
            clearInterval(timer)
          }
        }, 25);
      if (prop) {
        elem[style] = from+unit
      } else {
        elem.style[style] = from+unit
      }
    },
    scrollTo: function (elemId) {
      var target = document.getElementById(elemId)
      this.animate(document.scrollingElement || document.documentElement, "scrollTop", "", 0, target.offsetTop+200, 700, true)
    },
    calculateStars: function (val) {
      let parent = this
      let decimal = Math.floor(val)
      let float = 0
      float = val - decimal
      for (let i = 0; i < decimal; i++) {
        parent.$set(parent.stars, i, 'star')
      }
      if (float > 0) {
        parent.$set(parent.stars, decimal, 'star_half')
      }
    }
  },
  mounted () {
    this.calculateStars(this.rating)
  },
  watch: {
    rating: function (val, oldValue) {
      this.calculateStars(val)
    },
    count: function (val, oldValue) {
      this.loadedRatingCount = val
    }
  }
}
</script>

<style lang="scss" scoped>
  .stars {
    i {
      color: #f1a444;
      font-size: 1rem;
      margin-right: -0.2rem;
      vertical-align: middle;
      margin-top: -0.1rem;
    }
  }
  .fa-star {
    position: relative;
    color: #c0c0c0;
  }
  .checked {
    color: #f1a444;
  }
  .half {
    position: absolute;
    left: 0;

    &:before {
      content: "\f089";
    }
  }
</style>
